import { c as _c } from "react/compiler-runtime";
import { Box, VStack } from '@chakra-ui/react';
import { OnboardingStepNav } from '@src/components/sco/Onboarding/Layout/OnboardingStepNav';
import React, { ReactNode } from 'react';
type OnboardingMainPanelProps = {
  children: ReactNode | ReactNode[];
  onNext?: () => any;
  hideNav?: boolean;
};
export const OnboardingMainPanel = props => {
  const $ = _c(8);
  let t0;
  if ($[0] !== props.children) {
    t0 = <Box paddingBottom="5em">{props.children}</Box>;
    $[0] = props.children;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== props.hideNav || $[3] !== props.onNext) {
    t1 = !props.hideNav && <><OnboardingStepNav onNext={props.onNext} /></>;
    $[2] = props.hideNav;
    $[3] = props.onNext;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== t0 || $[6] !== t1) {
    t2 = <VStack align="stretch" alignSelf="stretch" gap={0} height="full" justify="stretch" justifySelf="stretch" width="full">{t0}{t1}</VStack>;
    $[5] = t0;
    $[6] = t1;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return t2;
};